import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export function useDirectoryTagCategories(eventId, directoryId) {
    const selector = useCallback((state) => state.events[eventId]?.directoryTags[directoryId], [eventId, directoryId]);
    return useSelector(selector) ?? [];
}
